import 'normalize.css'
import 'animate.css'
// import './assets/css/default/main.css'
import './assets/css/main.css'

import './bootstrap'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createCore, fetchConfig } from './core'
import type { Config } from './types/Config'

import App from './App.vue'
import router from './router'
;(async () => {
  // ---------------------------
  $config = await fetchConfig<Config>()
  $lang.value = $config.startupLang
  // ---------------------------
  const app = createApp(App)
  app.use(createPinia())
  app.use(router)
  app.use(createCore())
  app.mount('#app')
  // ---------------------------
})()
